import { Theme } from '@mui/material'
import { makeStyles, createStyles } from '@mui/styles'
import { memo } from 'react'

import Address from './sections/Address'
import Conditions from './sections/Conditions'
import DocsNeeded from './sections/DocsNeeded'
import Features from './sections/Features'
import PayoutDuration from './sections/PayoutDuration'
import { PAYOUT_DURATION_MAP } from './sections/typings'

import { IProductDetails } from './typings'

const useStyles = makeStyles<Theme, { isPayoutDurationVisible: boolean }>(
  (theme: Theme) =>
    createStyles({
      productDetailsGrid: {
        display: 'flex',
        flexDirection: 'column',
      },
      detailsRowOne: {
        display: 'grid',
        gridAutoFlow: 'column',
        alignItems: 'center',
        minHeight: 220,
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
        [theme.breakpoints.up('md')]: {
          gridTemplateColumns: ({ isPayoutDurationVisible }) =>
            isPayoutDurationVisible ? '275px 1fr 1fr' : '1fr 1fr',
        },
        [theme.breakpoints.down('md')]: {
          gridAutoFlow: 'row',
          gridTemplateColumns: '1fr',
          border: '0',
        },
      },
      detailsRowTwo: {
        display: 'grid',
        gridAutoFlow: 'column',
        gridTemplateColumns: '1fr 300px',
        alignItems: 'center',
        minHeight: 190,
        [theme.breakpoints.down('md')]: {
          gridAutoFlow: 'row',
          gridTemplateColumns: '1fr',
          border: '0  ',
        },
      },
    }),
)

const BankItemProductDetails = ({
  bank,
  features,
  conditions,
  images,
}: IProductDetails) => {
  const { productDetailsGrid, detailsRowOne, detailsRowTwo } = useStyles({
    isPayoutDurationVisible:
      features?.payoutDuration !== PAYOUT_DURATION_MAP.unknown &&
      !!features?.payoutDuration,
  })
  return (
    <div className={productDetailsGrid}>
      {/* Do not remove div, safari fix */}
      <div>
        <div className={detailsRowOne}>
          {features?.payoutDuration !== PAYOUT_DURATION_MAP.unknown && (
            <PayoutDuration duration={features.payoutDuration} />
          )}
          <DocsNeeded />
          <Features features={features} />
        </div>
      </div>
      {/* Do not remove div, safari fix */}
      <div>
        <div className={detailsRowTwo}>
          <Conditions conditions={conditions} />
          <Address address={bank.address} logos={images} />
        </div>
      </div>
    </div>
  )
}

export default memo(BankItemProductDetails)
